export default {
  feedbackThanksHeader: { id: 'feedback_thanks_header' },
  feedbackThanksContent: { id: 'feedback_thanks_content' },
  addMoreFeedback: { id: 'add_more_feedback' },
  leaveFeedback: { id: 'leave_feedback' },
  feedbackTypeIdeas: { id: 'feedback_type_ideas' },
  feedbackTypeBugs: { id: 'feedback_type_bugs' },
  feedbackTypeOther: { id: 'feedback_type_other' },
  saveBtn: { id: 'save_btn' },
  email: { id: 'email' },
  comment: { id: 'comment' },
  send: { id: 'send' },
  feedbackType: { id: 'feedback_type' },
  afterSaveFeedbackMessage: { id: 'after_save_feedback_message' },
}
